import { includes } from 'lodash-es'
import { PermissionRole } from '../auth/type'
import { ChannelTypeEnum } from '@/api/base/enums'
import { type Channel, ChannelPermissionType } from '@/store/modules/channel-framework/types'

export const defaultChannel: Channel = {
  id: 'ROOT',
  name: '',
  level: 0,
  children: [],
  _id: '',
  organizationLeaderId: '',
  organizationLeaderName: '',
  permissionView: ChannelPermissionType.NONE,
  hasPermission: false,
  rolePermission: PermissionRole.Guest,
}

export const isChannelType = [ChannelTypeEnum.Channel, ChannelTypeEnum.ChannelInUser]
export const isChannel = (channel: Channel) => includes(isChannelType, channel._channelType)
